module.exports = __webpack_public_path__ + "static/media/qr-code.9ce4d084.svg";